module.exports = __webpack_public_path__ + "static/media/research.5f018189.jpg";